
import { Component, Vue, Watch } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import CookieMessage from '@/components/CookieMessage.vue';
import OfflineActionDialog from '@/components/dialogs/OfflineActionDialog.vue';
import OfflineActionHandler from '@/assets/ts/OfflineActionHandler';
import ConnectionUtils from '@/assets/ts/connection_utils';
import Service from '@/services/Service';

@Component({
    components: {
        OfflineActionDialog,
        CookieMessage,
        Header,
    },
})
export default class App extends Vue {

    private cookieConsent: boolean = false;
    private offlineAction: string = '';

    @Watch('$route')
    private async onRouteChange() {
        const element1 = document.getElementById('scrollableAppBodyNoHeader');
        const element2 = document.getElementById('scrollableAppBody');
        if (element1 !== null) {
            element1.scrollTop = 0;
        }
        if (element2 !== null) {
            element2.scrollTop = 0;
        }
    }

    private created() {
        this.onRouteChange();
        document.title = 'Oltmanns Metallbau';
        if (localStorage.getItem('OMB_COOKIE_CONSENT') === 'TRUE') {
            this.cookieConsent = true;
        }
        this.evaluateBodyScrollbar();
        OfflineActionHandler.setHandler((action) => {
            this.offlineAction = action;
        });
        window.addEventListener('resize', this.evaluateBodyScrollbar);

        Service.reports.saveAllSignedOfflineReports();
        ConnectionUtils.addConnectionChangeListener(this.onConnectionChange);
    }

    private onConnectionChange(isOnline: boolean) {
        if (!isOnline) return;

        Service.reports.saveAllSignedOfflineReports();
    }

    private evaluateBodyScrollbar() {
        const body = document.getElementById('scrollableAppBodyNoHeader');
        if (body !== null) {
            if ((body.scrollHeight - 6) > window.innerHeight) {
                body.style.overflowY = 'auto';
            } else {
                body.style.overflowY = 'hidden';
            }
        }
    }
}
